import React from 'react';
import { useTranslation } from 'react-i18next';

const IkeTaxBenefits: React.FC = () => {
  const { t } = useTranslation('ike-or-ikze');

  return <ul>
      <li>
        {t('ike.tax_benefits')}
      </li>
    </ul>;
};

export default IkeTaxBenefits;
